import { render, staticRenderFns } from "./updateRole.vue?vue&type=template&id=401832d2&scoped=true&"
import script from "./updateRole.vue?vue&type=script&lang=js&"
export * from "./updateRole.vue?vue&type=script&lang=js&"
import style0 from "./updateRole.vue?vue&type=style&index=0&id=401832d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401832d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('401832d2')) {
      api.createRecord('401832d2', component.options)
    } else {
      api.reload('401832d2', component.options)
    }
    module.hot.accept("./updateRole.vue?vue&type=template&id=401832d2&scoped=true&", function () {
      api.rerender('401832d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/role/updateRole.vue"
export default component.exports